<template>
  <form ref="form">
    <div class="question-text" v-html="getQuestionText"></div>

    <div v-if="data.header" class="model model-header">
      <div class="spacer">&nbsp;</div>
      <div class="header-wrapper">
        <div class="header-left">
          <label v-html="getModelHeaderLeft()"></label>
        </div>
        <div class="header-right">
          <label v-html="getModelHeaderRight()"></label>
        </div>
      </div>
      <div class="header-other">
        <label v-html="getModelHeaderOther()"></label>
      </div>
    </div>

    <div class="model">
      <div class="spacer">&nbsp;</div>
      <div v-for="(model, index) in data.model" :key="index" class="header">
        <label v-html="getModelText(model.label)"></label>
      </div>
    </div>

    <div v-for="(choice, index) in data.choices" :key="index" class="multiple-item">
      <div class="input-group" :class="isChecked(choice.id)">
        <label :for="`input_${choice.id}`" v-html="getChoiceText(choice.id)">
        </label>

        <template v-if="isSpecial(choice)">
          <label>
            <input type="text"
              class="input-special"
              :ref="`custom_${choice.id}`"
              @keyup="setCustomValue(choice)"
            />
          </label>
        </template>

        <template v-else>
          <label :for="`input_${choice.id}_${modelIdx}`" v-for="(model, modelIdx) in data.model" :key="modelIdx">
            <input type="checkbox"
              :id="`input_${choice.id}_${modelIdx}`"
              :name="`input[${choice.id}]`"
              :ref="`input[${choice.id}][${modelIdx}]`"
              :value="model.value"
              @change="selected(choice, model.value, modelIdx)"
            />
          </label>
        </template>

      </div>
    </div>

    <button type="button" class="previous" @click="prev">Previous</button>
    <button
      @click.prevent="next"
      :disabled="nextBtnDisabled"
      :class="{ active: !nextBtnDisabled }"
      class="next"
    >
      Next
    </button>

  </form>
</template>

<script>
export default {
    name: 'multiple-table-checkbox',

    props: {
      data: {
        required: true,
        type: Object
      }
    },

    data() {
        return {
            nextBtnDisabled: true,
            answer: {
              question: this.data.id,
              choices: []
            },
            customValue: ''
        }
    },

    methods: {
        selected(choice, value, modelIdx){
          let checkbox = this.$refs[`input[${choice.id}][${modelIdx}]`][0];
          let index = this.answer.choices.findIndex(c => c.id === choice.id);
          if ( index > -1 ){
            let customs = this.answer.choices[index].custom.split(';');
            if ( checkbox.checked ){
              customs.push(value);
              let newCustom = customs.join(';');
              this.answer.choices[index].custom = newCustom;
            } else {// when unchecked
              let customIdx = customs.findIndex(item => item === value);
              customs.splice(customIdx, 1);

              if ( customs.length === 0 ){
                this.answer.choices.splice(index, 1)
              } else {
                let newCustom = customs.join(';');
                this.answer.choices[index].custom = newCustom;
              }
            }
          } else {
            this.answer.choices.push({
              id: choice.id,
              custom: value
            })
          }
        },

        setCustomValue(choice) {
          console.log('setCustomValue %s', choice.id)
          this.selected(choice, `0:${this.$refs[`custom_${choice.id}`][0].value.trim()}`)
        },

        next(){
            this.$emit('next-question', this.answer)
        },

        prev() {
          this.$emit('prev-question');
        },

        isChecked(choiceId) {
          return this.answer.choices.find(c => c.id === choiceId) ? 'active' : '';
        },

        getChoiceText(choiceId) {
          const index = this.data.choices.findIndex(c => c.id == choiceId);
          const textIndex = this.data.choices[index].text.findIndex(t => t.lang == this.$parent.lang);
          return this.data.choices[index].text[textIndex].html;
        },

        getModelText(model) {
          const index = model.findIndex(m => m.lang == this.$parent.lang);
          return model[index].html;
        },

        getModelHeaderLeft() {
          const index = this.data.header.left.findIndex(h => h.lang == this.$parent.lang);
          return this.data.header.left[index].html;
        },

        getModelHeaderRight() {
          const index = this.data.header.right.findIndex(h => h.lang == this.$parent.lang);
          return this.data.header.right[index].html;
        },

        getModelHeaderOther() {
          const index = this.data.header.other.findIndex(h => h.lang == this.$parent.lang);
          return this.data.header.other[index].html;
        },

      isSpecial(choice) {
          return choice.id === 12758 // TODO: return true if choice.special
      }

    },

    computed: {
      getQuestionText() {
        const index = this.data.text.findIndex(t => t.lang == this.$parent.lang)
        return this.data.text[index].html;
      }
    },

    watch: {
      'answer.choices': function(val) {
        let disable = false;
        this.data.choices.forEach(function(choice){
          if(val.findIndex(answer => answer.id === choice.id) === -1){
            disable = true;
          }
        });
        if( disable ){
          this.nextBtnDisabled = true
        } else {
          this.nextBtnDisabled = false
        }
      }
    }

}
</script>